import { ENDPOINTS, getFullUrl } from './apiConfig';

/**
 * Logs in a user using username and password.
 * @param {object} credentials - The user credentials.
 * @param {string} credentials.email - The user's email or username.
 * @param {string} credentials.password - The user's password.
 * @returns {Promise<object>} - A promise that resolves with the API response data (token, user info).
 * @throws {Error} - Throws an error if the API call fails or returns a non-OK status.
 */
export const loginUser = async (credentials) => {
  const url = getFullUrl(ENDPOINTS.LOGIN);
  
  console.log('Sending POST request to:', url);
  console.log('Credentials:', { username: credentials.email, password: '***' }); // Log email as username, hide password

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      // Map email to username for backend compatibility
      body: JSON.stringify({ 
        username: credentials.email, 
        password: credentials.password 
      }),
    });

    // Check if the response status is OK (e.g., 200)
    if (!response.ok) {
      // Try to parse error details from the response body
      const errorDetails = await response.json().catch(() => ({})); // Default if JSON parsing fails
      console.error('API Login Error Response:', response.status, response.statusText, errorDetails);
      // Throw an error with combined information
      throw new Error(`API Error: ${response.status} ${response.statusText} - ${errorDetails.detail || errorDetails.error || 'Login failed.'}`);
    }

    // Parse the successful JSON response
    const result = await response.json();
    console.log('API Login Success Response:', { ...result, token: '***' }); // Log response, hide token
    return result; // Return the successful data including token and user info

  } catch (error) {
    console.error('Network or Fetch Error during login:', error);
    // Re-throw the error to be caught by the calling component
    if (error.message.startsWith('API Error:')) {
      throw error; 
    } else {
      throw new Error(`Network error: ${error.message}`);
    }
  }
};

// Add other auth-related functions here if needed (e.g., logout, register, refreshToken)
// export const logoutUser = async () => { ... };
